"use client";

import {
  HeroSection,
  PersonasSection,
  HomeMetricsBar,
  FeaturesBubblesSection,
  StatsSection,
  TestimonialsSection,
  FeaturesGridSection,
  MissionShowcaseSection,
  ServicesSection,
} from "@/components/sections/home";

/**
 * Composes the marketing homepage sections.
 * Copy lives in locale home.json files (Blob + static fallback via getMessages).
 */
export default function HomePage() {
  return (
    <>
      <HeroSection />
      <PersonasSection />
      <HomeMetricsBar />
      <FeaturesBubblesSection />
      <StatsSection />
      <TestimonialsSection />
      <FeaturesGridSection />
      <MissionShowcaseSection />
      <ServicesSection />
    </>
  );
}
